import { addTraits } from 'src/api';

export const getFormData = state => addTraits(state.account.formData);
